import axios from 'axios'

export default async function deleteGalleryPhoto(item_id: number) {
  await axios.delete(`/api/v1/gallery-photo/${item_id}`, { useRetry: true })
}
